(function () {
    'use strict';

    angular.module("imApp").factory("cargonizerPrintersService", ['$ihttp', function ($ihttp) {
        let service = {
            listCargonizerPrinters: function (parms) {
                return $ihttp.post({
                    method: 423,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();	
